$(document).ready(function() {
	//Pull through all scripts in customScripts function
   	customScripts();

});


//Primary scripts function
function customScripts() {


	/*  ==========================================================================
		Custom Events
		========================================================================== */
		//Initialise Animate on Scroll
	  	AOS.init({
		  	startEvent: 'load'
		});

	    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
	     	var evt = document.createEvent('UIEvents');
	     	evt.initUIEvent('resize', true, false, window, 0);
	     	window.dispatchEvent(evt);
	    } else {
	       	window.dispatchEvent(new Event('resize'));
	    }

		
	/*  ==========================================================================
		jQuery Plugins
		========================================================================== */	

		//Slickslider
		// $('.team-carousel').slick({
		//   	infinite: true,
		//   	slidesToShow: 6,
		//   	slidesToScroll: 6,
		//   	centerMode: true,
		//   	prevArrow : '<div class="slick-prev"><i></i></div>',
		//     nextArrow : '<div class="slick-next"><i></i></div>'
		// });



		//Matchheight.js	
		// $('.pricing-content-mh').matchHeight({ remove: true });
		// $('.pricing-content-mh').matchHeight();
		
		// $.fn.matchHeight._update();


		//ACF Maps
		// $('#acf-map').each(function(){
		// 	// create map
		// 	map = new_map( $(this) );
		// });


};